export default __webpack_public_path__ + "static/media/background-supply.7890afac.jpg";